export const shareButtonDataByRoute: { [key: string]: { webSharePath: string; referringComponent: string } } = {
  "explore-displayName": {
    webSharePath: "creator-shop-share",
    referringComponent: "creator shop",
  },
  "explore-displayName-posts-id": {
    webSharePath: "post-page-share",
    referringComponent: "post page",
  },
  "explore-displayName-collections-id": {
    webSharePath: "collections-details-page-share",
    referringComponent: "creator shop collection detail page",
  },
  "explore-displayName-productsets-id": {
    webSharePath: "product-set-details-page-share",
    referringComponent: "creator shop product sets detail page",
  },
  "explore-displayName-giftguides-id": {
    webSharePath: "gift-guide-details-page-share",
    referringComponent: "creator shop gift guides detail page",
  },
  "account-favorites-products": {
    webSharePath: "favorited-products-share",
    referringComponent: "favorites products page",
  },
  "collections-hash": {
    webSharePath: "wishlist-details-page-share",
    referringComponent: "wishlist details page",
  },
};

export default shareButtonDataByRoute;
